import request from '@/utils/request'

// 首頁大屏數據
export function homeDev (query) {
  return request({
    url: '/screen/device/statistics',
    method: 'get',
    params: query
  })
}
// 设备报警数据
export function alarmList (query) {
  return request({
    url: '/screen/device/alarm/list',
    method: 'get',
    params: query
  })
}
// 首页数据统计
export function homeStatistics (query) {
  return request({
    url: '/home/statistics',
    method: 'get',
    params: query
  })
}